/**
 * Меню поставщика — куда можно уйти с имени поставщика из любого экрана
 * (разметка владельца 25.09.26). Спека: `docs/specs/2026-09-25-supplier-card-design.md`.
 *
 * Товары — через `productsHref`, а не строкой: у «Товаров» свой разбор адреса.
 */
import { createContext } from "react";

import { productsHref } from "@/lib/similar";

export type SupplierMenuItem = { key: string; label: string; href: string };

/** Пункт экрана: `sameTab` — переход в этой вкладке (исключение из отбора);
 *  `disabled` — почему пункт неактивен (подсказкой). */
export type SupplierExtraItem = SupplierMenuItem & { sameTab?: boolean; disabled?: string };

/**
 * Пункты экрана поверх общего меню (разметка 05.11.26 13:51): «Товары» дают
 * «списком», «карточками» и «исключить из отбора». Есть пункты экрана — общие
 * пять уходят в раскрывающееся «Старое». Контекстом, а не пропсом: в виде
 * «список» имя поставщика сидит на четвёртом этаже компонентов.
 */
export const SupplierMenuExtras = createContext<((id: number) => SupplierExtraItem[]) | null>(null);

export function supplierCardHref(id: number): string {
  return `/supplier/${id}`;
}

/** Пункты меню по правам; «Карточку» можно выключить — на самой карточке она лишняя. */
export function supplierMenuItems(
  id: number,
  can: { orders: boolean; payments: boolean },
  withCard = true,
): SupplierMenuItem[] {
  const items: SupplierMenuItem[] = [];
  if (withCard) items.push({ key: "card", label: "Карточка поставщика", href: supplierCardHref(id) });
  items.push({ key: "products", label: "Все товары", href: productsHref(id) });
  items.push({ key: "plans", label: "Планы", href: `/plans?supplier=${id}` });
  if (can.orders) items.push({ key: "orders", label: "Заказы", href: `/orders?supplier=${id}` });
  if (can.payments) items.push({ key: "payments", label: "Оплаты", href: `/finance/payments?view=list&supplier=${id}` });
  return items;
}
